"use strict";
import { gsap } from "gsap";

window.addEventListener(
  'load',
  () => {
    gsap
      .timeline({
        defaults: {
          ease: "power2.out",
        },
      })
      /* square */
      .to(".work-single-square__cont",
        {
          ease: "Power2.easeInOut",
          duration: 0.3,
          x: 0,
          stagger: {
            from: "random",
            amount: 0.3
          }
        },
        0
      )
      .add(function() {
        document.querySelector(".work-single-kv__figure").classList.add("exit");
      }, 0.6)
      .add(function() {
        document.querySelector(".work-single-kv__ttl").classList.add("exit");
      }, 0.9)
      .to(".work-single-kv__detail",
        {
          ease: "Power1.easeIn",
          opacity: 1,
          duration: 0.5,
        },
        1.2
      )
    },
    false
  );
